import type {BalanceByTeamItem} from "../../../api/admin/merchantBalance";

/**
 * Какую команду ПОДСКАЗАТЬ для разноски заявки, закрытой площадкой.
 *
 * Правило то же, по которому её выбирал разовый скрипт: команда, которая уже
 * держит срез по этому мерчанту. Если такая ровно одна — почти наверняка она
 * заявку и выполнила: кабинет обслуживает одна команда, и её строки в леджере
 * это уже показывают.
 *
 * Ноль и «больше одной» дают одинаковый ответ — null, — и это не лень. Система
 * не знает, кто выполнил заявку в кабинете площадки: она не проходила через
 * нашего трейдера вовсе. Подставить «первую попавшуюся» значило бы начислить
 * деньги по догадке, а отличить догадку от решения человека потом будет нечем.
 *
 * Строки без команды (`teamId` пустой — неатрибутированное легаси) в счёт не
 * идут: они не называют никого.
 */
export function suggestSettlementTeam(items: BalanceByTeamItem[]): string | null {
    const holders = items.filter((item) => item.teamId);
    return holders.length === 1 ? holders[0].teamId : null;
}
